import * as React from 'react';
import { sideRailTypes } from './master-page';
import { MainRegion } from './main-region';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

export interface BodyRegionProps {
  toolbarType: string;
  mainContent: React.ReactElement<{}>;
  sideRailContent: React.ReactElement<{}>;
  toolbarContent: React.ReactElement<{}>;
  sideRailType: string;
}

const mainDefault = (
  <MainRegion>
    <h1>No content has been set for main region</h1>
  </MainRegion>
);

export class BodyRegion extends React.Component<BodyRegionProps> {
  public render() {
    const { mainContent, sideRailContent, toolbarContent, sideRailType } = this.props;

    const mainContentRegion = <ErrorBoundary label="hotel.masterPage.main">{mainContent || mainDefault}</ErrorBoundary>;
    const sideRailContentRegion = sideRailContent && <ErrorBoundary label="hotel.masterPage.sideRail">{sideRailContent}</ErrorBoundary>;
    const toolbarContentRegion = toolbarContent && (
      <div className={['pwa-toolbar', this.props.toolbarType].join(' ')}>
        <ErrorBoundary label="hotel.masterPage.toolbar">{toolbarContent}</ErrorBoundary>
      </div>
    );

    if (sideRailType === sideRailTypes.NEXT_TO_MAIN) {
      return (
        <React.Fragment>
          {toolbarContentRegion}
          <div className="uitk-flex two-column-body">
            <div className="uitk-flex-grow-1 uitk-cell xl-x-padding-six">{mainContentRegion}</div>
            <div className="uitk-flex-shrink-1 side-rail">{sideRailContentRegion}</div>
          </div>
        </React.Fragment>
      );
    } else if (sideRailType === sideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR) {
      return (
        <div className="uitk-flex two-column-body">
          <div className="uitk-flex-grow-1 uitk-cell xl-x-padding-six">
            {toolbarContentRegion}
            {mainContentRegion}
          </div>
          <AbacusExperiment name="MeSo_move_R1_under_toolbar">
            <AbacusControl>
              <div className="uitk-flex-shrink-1 side-rail">{sideRailContentRegion}</div>
            </AbacusControl>
            <AbacusVariant bucket={1}>
              <div className="uitk-flex-shrink-1 side-rail toolbar-padding">{sideRailContentRegion}</div>
            </AbacusVariant>
          </AbacusExperiment>
        </div>
      );
    }

    return (
      <React.Fragment>
        {toolbarContentRegion}
        {mainContentRegion}
      </React.Fragment>
    );
  }
}
